export const filterConfigs = [
  {key: 'name', type: 'search', init: null, title: "Search Portfolios"},
  { key: 'type', type: 'category', init: null, title: "Filter by Type", multi: true, placeholder: "Portfolio Types" },
];

export const filterUniqueGroupNames = (portfolios) => {
  return [
    ...new Set(
      portfolios
        .map((p) => p?._user?.group_name)
        .filter((groupName) => groupName !== null && groupName !== undefined) // Filter out null/undefined
    ),
  ];
};

export const countPortfoliosWithSignals = (portfolios)=>{
    let count = 0;
    portfolios.forEach(record=>{
        if (record?._user?.last_update || 0 > record?._user?.last_ack){
            count++;
        }
    });
    return count;
}